/**
 * Maps legacy or alternative tenant ID aliases to their canonical tenant IDs.
 * This is added to ensure existing users and bookmarks continue to resolve correctly without requiring manual re-entry.
 */
export const TENANT_ID_ALIASES: Record<string, string> = {
  b2b: 'league',
};

/**
 * Resolves a tenant ID alias to its canonical tenant ID.
 * If the given ID is not an alias, it is returned unchanged.
 *
 * @param tenantId - The tenant ID to normalize
 * @returns The canonical tenant ID
 */
export const resolveTenantIdAlias = (tenantId: string): string =>
  TENANT_ID_ALIASES[tenantId] ?? tenantId;
